import { APP_BUILD_VERSION } from 'src/config-global';
import posthog from 'src/utils/posthog';

import type { RedactionCounts } from './privacy/backstop';

export const ORCHESTRATOR_EVENTS = {
  taskCompleted: 'ai_orchestrator_task_completed',
  privacyResidualRedacted: 'ai_privacy_residual_redacted',
} as const;

export type TurnOutcome = 'answered' | 'refused' | 'budget_exhausted';

export type TurnStats = {
  outcome: TurnOutcome;
  toolCalls: number;
  toolErrors: number;
  confirmations: number;
  turnIndex: number;
  durationMs: number;
};

export type TurnIdentity = {
  platformId: string | null;
  userRole?: string;
};

export const trackTaskCompleted = (identity: TurnIdentity, stats: TurnStats) => {
  if (stats.outcome === 'refused') return;

  posthog.capture(ORCHESTRATOR_EVENTS.taskCompleted, {
    outcome: stats.outcome,
    tool_calls: stats.toolCalls,
    tool_errors: stats.toolErrors,
    confirmations: stats.confirmations,
    turn_index: stats.turnIndex,
    duration_ms: stats.durationMs,
    duration_seconds: Math.round(stats.durationMs / 1000),
    platform_id: identity.platformId,
    user_role: identity.userRole ?? null,
    app_version: APP_BUILD_VERSION,
  });
};

export const trackPrivacyResidualRedacted = (counts: RedactionCounts) => {
  posthog.capture(ORCHESTRATOR_EVENTS.privacyResidualRedacted, {
    phones: counts.PHONE ?? 0,
    emails: counts.EMAIL ?? 0,
    ids: counts.ID ?? 0,
    secrets: counts.SECRET ?? 0,
  });
};
